import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import HometaxTimeoutError from '@/components/tax-refund/common/view/ErrorView/HometaxTimeoutError';
import { COMMON_PATHS, CORPORATION_PATHS } from '@/lib/constants/paths';

const CorporationHometaxTimeoutErrorPage = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleClickExit = () => {
    sendClickEvent('corps-lookup_error-timeout_close');
    router.push(COMMON_PATHS.환급조회목록);
  };

  const handleRetry = () => {
    sendClickEvent('corps-lookup_error-timeout_retry');
    router.push({
      pathname: `${CORPORATION_PATHS.법인수집및조회}`,
      query: { type: 'corps' }
    });
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="corps-lookup_error-timeout" />
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <HometaxTimeoutError onPrimaryButtonClick={handleRetry} />
      </Layout>
    </AuthGuard>
  );
};

export default CorporationHometaxTimeoutErrorPage;
